import { memo } from "react";

const FullTextLazyLoading = () => {
  return (
    <div className="fulltext-loading-handle">
      <div
        className="d-flex flex-column align-items-flex-start w-100 py-2 gap-2 px-2"
        style={{ backgroundColor: "#ffffff" }}
      >
        <div className="full-text-lazy-1">
          <div
            className="stripe small-stripe rounded"
            style={{ width: "90%", height: "11px" }}
          />
          <div
            className="stripe small-stripe rounded"
            style={{ width: "45%", height: "11px" }}
          />
        </div>
        <div className="full-text-lazy-1">
          <div
            className="stripe small-stripe rounded"
            style={{ width: "90%", height: "11px" }}
          />
          <div
            className="stripe small-stripe rounded"
            style={{ width: "45%", height: "11px" }}
          />
        </div>
        <div className="full-text-lazy-1">
          <div
            className="stripe small-stripe rounded"
            style={{ width: "90%", height: "11px" }}
          />
          <div
            className="stripe small-stripe rounded"
            style={{ width: "45%", height: "11px" }}
          />
        </div>
        <div className="full-text-lazy-1">
          <div
            className="stripe small-stripe rounded"
            style={{ width: "90%", height: "11px" }}
          />
          <div
            className="stripe small-stripe rounded"
            style={{ width: "45%", height: "11px" }}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(FullTextLazyLoading);
